// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"79":"86b6d263","82":"eaa3b536","85":"b4f3cb83","226":"ad7ed645","351":"009566ee","428":"23a12cbe","477":"108ddac6","787":"ea386385","852":"a4f05600","858":"3fcb1f5d"}[chunkId] + ".js";
};